import * as React from "react";
import { Typography } from "@mui/material";
import image_1 from "../../assets/images/success-story-cyber-security.jpg";
import image_2 from "../../assets/images/success-story-bridge-design.jpg";
import image_3 from "../../assets/images/success-story-hackathon.jpg";
import image_4 from "../../assets/images/success-story-machine-learning.jpg";
import "./sliderr.css";
//import { motion } from 'framer-motion';
//import { useIsMobile } from "../../utils/mobileScreen";
import Carousel from 'react-bootstrap/Carousel';

const data = [
  {
          url: image_1,
          date: "1-2 Feb 2020",
          name: "Cyber Security",
          place: "IIT, Bhubaneswar",
          details:
            "The instructor for the Cyber Security course was a patient and adept mentor. He proactively resolved my queries and rendered respectful guidance when interacting with other students.",
        },
        {
          url: image_2,
          date: "1-2 Feb 2020",
          name: "Bridge Design",
          place: "IIT, Bhubaneswar",
          details:
            "The content for the Bridge Design Course was really informative and relevant. Working on projects with the use of tools provided helped me get acquainted with technology in a learning environment with ease.",
        },
        {
          url: image_3,
          date: "5 Nov 2021",
          name: "Hackathon",
          place: "LPU",
          details:
            "Learning from the Hackathon was truly an enriching experience. The way the course component was delivered exceeded my expectations.",
        },
        {
          url: image_4,
          date: "6 Dec 2021",
          name: "Machine Learning",
          place: "Osmania University",
          details:
            "The machine learning workshop helped me in two ways-by exposing me to challenging tasks in the form of real-world projects and extending professional development opportunities. I strongly recommend this workshop.",
        },
]

const Sliderr=()=>{
  const [index, setIndex] = React.useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return(
    <>
    {/* <motion.div 
      className="slider-div animate-margin"
      initial={[{ opacity: 0 }]}
      whileInView={[{ opacity: 1, marginLeft: 0 }]}
      transition={{ duration: 2 }}
      > */}
        <div className="story-heading">
        <Typography
          component="h2"
          className="techvanto-whyus-heading story-text"
        >
          Success Stories
        </Typography>
        </div>
        <Carousel
        //  interval={null}
        >
          <Carousel.Item style={{minHeight:'550px'}}>
            <div className="car-info">
              <div style={{marginTop:'2%',textAlign:'center'}}> 
                <p className="left">❝</p>         
                <p className="text-slider">The instructor for the Cyber Security course was a patient and adept mentor. He proactively resolved my queries and rendered respectful guidance when interacting with other students.</p>
              </div>
              <h3 style={{marginTop:'2%',textAlign:'center'}}>Cyber Security - IIT, Bhubaneswar</h3>
              <h3 style={{textAlign:'center'}}>1-2 February 2022</h3>
            </div>
            <div className="car-img">
              <img src={`${image_1}`} alt="first-slide"/>
            </div>
          </Carousel.Item>
          <Carousel.Item style={{minHeight:'550px'}}>         
            <div className="car-info">
            <div style={{marginTop:'2%',textAlign:'center'}}> 
              <p className="left">❝</p>         
              <p className="text-slider">The content for the Bridge Design Course was really informative and relevant. Working on projects with the use of tools helped me get acquainted with technology in a learning environment with ease.</p>
            </div>
            <h3 style={{marginTop:'2%',textAlign:'center'}}>Bridege Design - IIT, Bhubaneswar</h3>
            <h3 style={{textAlign:'center'}}>1-2 February 2022</h3>
            </div>
            <div className="car-img">
              <img src={`${image_2}`} alt="first-slide"/>
            </div>
            
          </Carousel.Item>
          <Carousel.Item  style={{minHeight:'550px'}}>
              <div className="car-info">
                <div style={{marginTop:'2%',textAlign:'center'}}> 
                  <p className="left">❝</p>         
                  <p className="text-slider">Learning from the Hackathon was truly an enriching experience. The way the course component was delivered exceeded my expectations. We are truely satisfied with workshop.</p>
              </div>
              <h3 style={{marginTop:'2%',textAlign:'center'}}>Hackathon - LPU</h3>
              <h3 style={{textAlign:'center'}}>5 November 2022</h3>
              </div>
              <div className="car-img">
                <img src={`${image_3}`} alt="first-slide"/>
              </div>      
          </Carousel.Item>
          <Carousel.Item style={{minHeight:'550px'}}>

            <div className="car-info">
            <div style={{marginTop:'2%',textAlign:'center'}}> 
              <p className="left">❝</p>         
              <p className="text-slider">The machine learning workshop helped in two ways-by exposing me to challenging tasks in the form of real-world projects and extending professional development opportunities.</p>
            </div>
            <h3 style={{marginTop:'2%',textAlign:'center'}}>Machine Learning - Osmania University</h3>
            <h3 style={{textAlign:'center'}}>6 December 2022</h3>
            </div>
            <div className="car-img">
              <img src={`${image_4}`} alt="first-slide"/>
            </div>
          </Carousel.Item>
        </Carousel>
        {/* </motion.div> */}
    </>
  )
}
export default Sliderr;

// const Sliderr = () => {
//   const [totalSlide] = React.useState(6);
//   const [currentSlide, setCurrentSlide] = React.useState(0);
//   // const handleArrow = (counter) => {
//   //   var newSlide = currentSlide + counter;
//   //   if (newSlide === totalSlide) newSlide = 0;
//   //   if (newSlide === -1) newSlide = totalSlide - 1;
//   //   setCurrentSlide(newSlide);
//   // };

//   const imageObject = [
//     {
//       url: image_1,
//       date: "1-2 Feb 2020",
//       name: "Cyber Security",
//       place: "IIT, Bhubaneswar",
//       details:
//         "The instructor for the Cyber Security course was a patient and adept mentor. He proactively resolved my queries and rendered respectful guidance when interacting with other students.",
//     },
//     {
//       url: image_2,
//       date: "1-2 Feb 2020",
//       name: "Bridge Design",
//       place: "IIT, Bhubaneswar",
//       details:
//         "The content for the Bridge Design Course was really informative and relevant. Working on projects with the use of tools provided helped me get acquainted with technology in a learning environment with ease.",
//     },
//     {
//       url: image_3,
//       date: "5 Nov 2021",
//       name: "Hackathon",
//       place: "LPU",
//       details:
//         "Learning from the Hackathon was truly an enriching experience. The way the course component was delivered exceeded my expectations.",
//     },
//     {
//       url: image_4,
//       date: "6 Dec 2021",
//       name: "Machine Learning",
//       place: "Osmania University",
//       details:
//         "The machine learning workshop helped me in two ways-by exposing me to challenging tasks in the form of real-world projects and extending professional development opportunities. I strongly recommend this workshop.",
//     },
//   ];

//   return (
//     <motion.div 
//       className="slider-div animate-margin"
//       initial={[{ opacity: 0 }]}
//       whileInView={[{ opacity: 1, marginLeft: 0 }]}
//       transition={{ duration: 2 }}
//       >
//       <div className="story-heading">
//         <Typography
//           component="h2"
//           className="techvanto-whyus-heading story-text"
//         >
//           Success Stories
//         </Typography>
//         {/* <div className="arrow-button">
//           <div className="left-arrow" onClick={() => handleArrow(-1)}>
//             ◄
//           </div>
//           <div className="right-arrow" onClick={() => handleArrow(1)}>
//             ►
//           </div>
//         </div> */}
//       </div>
//       {imageObject.map((data, index) => {
//         return (
//           <>
//           <div>
//           <Carousel fade>
//     <Carousel.Item>
//       <img
//         className="d-block w-50"
//         src={`${data.url[0]}`}
//         alt="First slide"
//       />
//       <Carousel.Caption>
//         <h3>{data.name[0]}</h3>
//         <p>{data.details[0]}</p>
//       </Carousel.Caption>
//     </Carousel.Item>
//     <Carousel.Item>
//       <img
//         className="d-block w-50"
//         src={`${data.url[1]}`}
//         alt="Second slide"
//       />
  
//       <Carousel.Caption>
//         <h3>{data.name[1]}</h3>
//         <p>{data.details[1]}</p>
//       </Carousel.Caption>
//     </Carousel.Item>
// </Carousel>
//           </div>
//           </>
//           // <>
//           //    <div className="carousal"
//           //     // className={
//           //     //   "slide none " +
//           //     //   (currentSlide === index ? "main-slide" : "") +
//           //     //   (currentSlide === (index - 1 + totalSlide) % totalSlide
//           //     //     ? "right-slide "
//           //     //     : "") +
//           //     //   (currentSlide === (index + 1) % totalSlide ? "left-slide " : "")
//           //     // }
//           //   >
//           //   <div className="carousel-indicators">
//           //     <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
//           //     <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
//           //     <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
//           //     <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 4"></button>
//           // </div>
//           //     <img
//           //       src={`${data.url}`}
//           //       width="100%"
//           //       height="100%"
//           //       className="active-image"
//           //       alt=""
//           //     ></img>
//           //     {currentSlide === index ? (
//           //       <p
//           //         className={
//           //           "techvanto-stories-upper-text" +
//           //           (currentSlide !== index ? "none" : "")
//           //         }
//           //       >
//           //         {data.date && (
//           //           <>
//           //             <span className="date">{data.date}</span>
//           //             <br></br>
//           //           </>
//           //         )}
//           //         <span className="place">
//           //           {data.name} - {data.place}
//           //         </span>
//           //       </p>
//           //     ) : (
//           //       ""
//           //     )}
//           //   </div> 
//           // </>
//         );
//       })}
//     </motion.div>
//   );
// };
// export default Sliderr;